export default "../images/stackloans-benefits.jpg?f83a0682184c306e7344493290bf2587";